export const DEFAULT_COUNTRY = 'USA';
export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_CURRENCY = 'USD';
export const DEFAULT_OFFICE = 'MIA';
export const DEFAULT_MARKET = 'usa';
export const DEFAULT_NAME_COUNTRY = 'UNITED STATES';
export const DEFAULT_NAME_PHONE_NUMBER = '866-562-7625';
export const DEFAULT_CURRENCIES = ['USD'];
export const DEFAULT_PATH = '/';
export const DEFAULT_COUNTRY_ALPHA2_CODE = 'us';
export const DEFAULT_LOCALE_CODE = 'en_US';

export const ISO_ALPHA_2_CODE_LENGTH = 2;
export const CEL_INTERNATIONAL_MARKET = 'int';

export const DEFAULT_LOCALE = {
	country: DEFAULT_COUNTRY,
	language: DEFAULT_LANGUAGE,
	currency: DEFAULT_CURRENCY,
	office: DEFAULT_OFFICE,
	market: DEFAULT_MARKET,
	nameCountry: DEFAULT_NAME_COUNTRY,
	phoneNumber: DEFAULT_NAME_PHONE_NUMBER,
	currencies: DEFAULT_CURRENCIES,
	path: DEFAULT_PATH,
	countryAlpha2Code: DEFAULT_COUNTRY_ALPHA2_CODE,
	code: DEFAULT_LOCALE_CODE,
};

export const dataTest = {
	query: {
		country: 'MEX',
		market: 'mex',
		language: 'es',
		currency: 'MXN',
	},
	response: {
		id: 'MEX_es_MXN',
		code: 'es_MX',
		path: '/mex/es/',
		language: { code: 'es', __typename: 'Language' },
		currency: { code: 'MXN', __typename: 'Currency' },
		market: { code: 'mex', __typename: 'Market' },
		country: {
			code: 'MEX',
			name: 'México',
			isoAlpha2Code: 'mx',
			phoneNumber: ['55-5062-9200'],
			office: { code: 'MEX', __typename: 'Office' },
			currencies: [
				{
					code: 'MXN',
					__typename: 'Currency',
				},
			],
			__typename: 'Country',
		},
		__typename: 'Locale',
	},
	localeMEX: {
		country: 'MEX',
		currency: 'MXN',
		language: 'es',
		market: 'mex',
		office: 'MEX',
		nameCountry: 'México',
		phoneNumber: '55-5062-9200',
		currencies: ['MXN'],
		path: '/mex/es/',
		countryAlpha2Code: 'mx',
		code: 'es_MX',
	},
};
